// extracted by mini-css-extract-plugin
export default {"container":"Select-Select-module__container--GYSzl","notFullWidth":"Select-Select-module__notFullWidth--HVha6"};